import { Reducer } from '@reduxjs/toolkit';

const selectedRecordReducer: Reducer = (
  state, { payload },
) => (
  {
    ...state,
    selectedRecord: payload,
  }
);

export default selectedRecordReducer;
